import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ArrowDown, Moon } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[90vh] flex items-center justify-center pt-20 pb-16 px-4 overflow-hidden bg-[#0f1419]" data-id="element-67">
      {/* Background Ambience */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(26,31,46,1)_0%,rgba(15,20,25,1)_100%)]" data-id="element-68" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#d4af37]/20 to-transparent" data-id="element-69" />

      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-70">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-71">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#1a1f2e] border border-[#2a3245] text-[#d4af37] text-sm font-medium mb-6" data-id="element-72">
            <Moon size={14} data-id="element-73" />
            <span data-id="element-74">Edición Nocturna</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 text-[#f5f0e8]" data-id="element-75">
            El dolor de tus manos <br data-id="element-76" />
            <span className="text-gold-gradient italic" data-id="element-77">
              te dicta cómo te acuestas
            </span>
          </h1>

          <p className="text-xl text-gray-400 mb-8 font-light leading-relaxed max-w-lg mx-auto lg:mx-0" data-id="element-78">
            Cómo te mueves. Y cuántas horas te roba. <br data-id="element-79" />
            <span className="text-[#f5f0e8] font-medium" data-id="element-80">
              Recupera tu descanso sin medicamentos.
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-81">
            <Button size="lg" onClick={scrollToPricing} data-id="element-82">
              Quiero dormir mejor
            </Button>
          </div>
        </motion.div>

        {/* Image Content */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative" data-id="element-83">
          <div className="relative rounded-2xl overflow-hidden shadow-[0_0_50px_rgba(0,0,0,0.5)] border border-[#2a3245]/50" data-id="element-84">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0f1419]/80 via-transparent to-transparent z-10" data-id="element-85" />
            <img src="https://cdn.magicpatterns.com/uploads/auGfLWAYdHo3qbJjA39GGZ/heylloyd-image-1769921245753.png" alt="Sueño Sin Dolor Guía Digital" className="w-full h-auto object-cover" data-id="element-86" />
          </div>

          {/* Decorative Elements */}
          <div className="absolute -z-10 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#d4af37]/5 rounded-full blur-3xl" data-id="element-87" />
        </motion.div>
      </div>
    </section>;
}